module.exports = __webpack_public_path__ + "img/slack-ronaldo_triste.4bd1c903.png";